/* @flow */

import * as types from 'src/shared/domain/topic/action/topicActionTypes';
import {
  createReducer,
  setLazyRequestResult,
  // setFetchingState,
} from 'src/shared/core/util/reducerUtils';

import type { State } from 'src/shared/core/type/reduxTypes';

const initialState = {};

const _setFetchingState = (state: State, { userId }: Object) => ({
  ...state,
  [userId]: { ...(state[userId] || {}), isFetching: true },
});

const _setRequestResult = (state: State, action: Object) => ({
  ...state,
  [action.userId]: setLazyRequestResult(state[action.userId], action),
});

export default createReducer(initialState, {
  [types.LAZY_FETCH_TOPICS_REQUEST]: _setFetchingState,
  [types.LAZY_FETCH_TOPICS_SUCCESS]: _setRequestResult,
  [types.FETCH_TOPICS_REQUEST]: _setFetchingState,
  [types.FETCH_TOPICS_SUCCESS]: _setRequestResult,
});
